import { ICaixaEmployeeRegisterForm } from '../store'

export const handleCaixaFormValidity = (formState: ICaixaEmployeeRegisterForm): ICaixaEmployeeRegisterForm => {
  let isFormValid = true

  const requiredFields = [
    'contactName', 'email', 'password', 'confirmPassword', 'phone',
    'caixaRole', 'caixaDepartment', 'caixaMatricula'
  ]

  requiredFields.forEach(fieldName => {
    const field = formState.form[fieldName]
    if (field.isRequired && (!field.value || field.value.trim() === '')) {
      isFormValid = false
    }
    if (field.isInvalid) {
      isFormValid = false
    }
  })

  if (formState.form.password.value !== formState.form.confirmPassword.value) {
    isFormValid = false
  }

  return {
    ...formState,
    isFormValid
  }
}

export const validateCaixaEmail = (email: string): { isValid: boolean; message: string } => {
  if (!email || email.trim() === '') {
    return { isValid: false, message: 'E-mail é obrigatório' }
  }

  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
  if (!emailRegex.test(email)) {
    return { isValid: false, message: 'Por favor, insira um e-mail institucional no formato nome@caixa.gov.br' }
  }

  if (!email.endsWith('@caixa.gov.br')) {
    return { isValid: false, message: 'Por favor, insira um e-mail institucional no formato nome@caixa.gov.br.' }
  }

  return { isValid: true, message: '' }
}